import store from '~/store'

export default async (to, from, next) => {
  if (!store.getters['auth/check']) {
    localStorage.intended_url = to.path

    next({ name: 'login' })
  } else {
    next()
  }
}
